import { AuthenticatedApiError, postAuthenticatedApi } from './postAuthenticatedApi';

export interface ValidatePromoCodeResult {
  promotionType: string;
  promotionRef: string;
  promotionCode: string;
  success: boolean;
}

export interface RedeemPromotionResult {
  accountNumber?: string;
  activationUrl?: string;
  emailAddress?: string;
  planCode?: string;
  platformName?: string;
  success: boolean;
  contractCreated?: boolean;
  welcomeNotificationSent?: boolean;
  isSuccessful?: boolean;
  action?: string;
  message?: string;
  errorCode?: string;
}

export type RedemptionOrigin = 'MOBILE' | 'PORTAL';

export interface RedeemPromotionCodeInput {
  origin: RedemptionOrigin;
  promotionCode: string;
  promotionRef?: string;
  accountVehicleId?: string;
}

export interface RedeemPromotionCodeResult {
  id?: string;
  codeDetailId?: string;
  campaign?: {
    id?: string;
    codeDetailId?: string;
    promoBenefitUrl?: string;
    mobileDescription?: string;
    groupDisplayName?: string;
    acceptButtonLabel?: string;
    portalUrl?: string;
    useByDays?: number;
    planId?: string;
    plan?: {
      planDisplayName?: string;
    } | null;
    promotionId?: string;
    promotion?: {
      id?: string;
      promotionRef?: string;
      promotionName?: string;
    } | null;
    promotionType?: string;
    codeTypeId?: string;
  } | null;
  redemptionTimestamp?: string;
  codeValue?: string;
  contractId?: string;
  accountId?: string;
}

export class PromotionClientError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'PromotionClientError';
  }
}

async function postPromotionApi<T>(path: string, body: unknown): Promise<T> {
  try {
    return await postAuthenticatedApi<T>(path, body);
  } catch (error) {
    if (error instanceof AuthenticatedApiError) {
      throw new PromotionClientError(error.message);
    }
    throw error;
  }
}

export async function validatePromoCodeRequest(input: {
  promotionCode: string;
  promotionRef: string;
}): Promise<ValidatePromoCodeResult> {
  const data = await postPromotionApi<{ validatePromoCode: ValidatePromoCodeResult }>('/api/promotion/validate', input);
  return data.validatePromoCode;
}

export async function redeemPromotionRequest(input: Record<string, unknown>): Promise<RedeemPromotionResult> {
  const data = await postPromotionApi<{ redeemPromotion: RedeemPromotionResult }>('/api/promotion/redeem', { input });
  return data.redeemPromotion;
}

export async function redeemPromotionCodeRequest(input: RedeemPromotionCodeInput): Promise<RedeemPromotionCodeResult> {
  const data = await postPromotionApi<{ redeemPromotionCode: RedeemPromotionCodeResult }>(
    '/api/promotion/redeem-code',
    { input },
  );
  return data.redeemPromotionCode;
}
